import awsConfig from '../aws-exports'
import { Auth } from 'aws-amplify'
import AWSAppSyncClient from 'aws-appsync'
import fetch from 'isomorphic-unfetch'
import { AUTH_TYPE } from 'aws-appsync/lib/link/auth-link'

export const publicClient = new AWSAppSyncClient({
  url: awsConfig.aws_appsync_graphqlEndpoint,
  region: awsConfig.aws_appsync_region,
  auth: {
    type: AUTH_TYPE.API_KEY,
    apiKey: awsConfig.aws_appsync_apiKey,
  },
  disableOffline: true,
  offlineConfig: {
    keyPrefix: 'public',
  },
  fetch,
})

export const client = new AWSAppSyncClient({
  url: awsConfig.aws_appsync_graphqlEndpoint,
  region: awsConfig.aws_appsync_region,
  auth: {
    // @ts-ignore
    type: awsConfig.aws_appsync_authenticationType,
    jwtToken: async () => {
      try {
        const currSession = await Auth.currentSession()
        return currSession.getAccessToken().getJwtToken()
      } catch (e) {
        return null
      }
    },
  },
  fetch,
  disableOffline: true,
})
